export default 'apyRates'
